import React from "react";
import Child from "./Child";
import classNames from "../../classNames";
import "./Styles.css";

const defaultIcon = "bi bi-journal-text";
const defaultProps = {
  onClick: () => {},
};

function Item({ menu, onClick, activeItem, setActiveItem }) {
  const { name, icon, label, disabled } = menu;
  const route = menu.route || "/" + name;
  const isActive = activeItem === route; // Check if the current item is active

  if (Array.isArray(route)) {
    return <Child menu={menu} onClick={onClick} />;
  }

  return (
    <li className="nav-item mb-3" key={route}>
      <a
        onClick={(e) => {
          e.preventDefault();
          setActiveItem(route); // Set active item
          onClick(e, menu);
        }}
        href={route}
        className={classNames(
          "nav-link text-truncate",
          isActive ? "bg-orange text-white p-2" : "text-dark", // Apply background color when active
          disabled ? "disabled" : ""
        )}
        style={{ borderRadius: "5px" }}
      >
        <i className={icon || defaultIcon}></i>
        <span className="ms-2">{label || name}</span>
      </a>
    </li>
  );
}

Item.defaultProps = defaultProps;
export default Item;
